import { useForm } from 'react-hook-form';
import { toIcons } from '../../consts/Paths';
import useIsMobile from '../../hooks/useIsMobile';
import CustomInput from '../inputs/CustomInput';
import { useEffect, useState } from 'react';
import useVendors from '../../api/hooks/useVendors';
import useShippingRules from '../../api/hooks/useShippingRules';
import { logMsgBgColors } from '../../consts/misc';

const SettingsCreateVendorModal = (props: any) => {
    const { CTAs, RESPONSES } = useVendors();
    const { RESULTS: RULES_RESULTS, CTAs: RULES_CTAs } = useShippingRules();
    const { isMobile } = useIsMobile();
    const createForm = useForm();
    const { write } = props.logMessage;
    const [shippingRules, setShippingRules] = useState<{ id: number; name: string }[]>([]);
    const [selectedRuleIds, setSelectedRuleIds] = useState<number[]>([]);

    useEffect(() => {
        RULES_CTAs.getShippingRules();
    }, []);

    useEffect(() => {
        if (RULES_RESULTS.getShippingRulesResult) {
            setShippingRules(
                (RULES_RESULTS.getShippingRulesResult || []).map((r: any) => ({
                    id: r.id,
                    name: r.name,
                }))
            );
        }
    }, [RULES_RESULTS.getShippingRulesResult]);

    const onSubmit = (data: any) => {
        CTAs.createVendor({
            name: data.name,
            code: data.code || undefined,
            shipping_rule_ids: selectedRuleIds.length ? selectedRuleIds : undefined,
        });
    };

    const toggleRule = (ruleId: number) => {
        setSelectedRuleIds((prev) =>
            prev.includes(ruleId) ? prev.filter((id) => id !== ruleId) : [...prev, ruleId]
        );
    };

    useEffect(() => {
        if (RESPONSES.createVendorResponse?.ok) {
            write('subject', 'Vendor ');
            write('other_text', 'has been added ');
            write('complement', 'successfully!');
            write('bgColor', logMsgBgColors.correct);
            props.toggler.toggle();
            props.resetList.toggle();
        } else if (RESPONSES.createVendorResponse?.ok === false) {
            write('subject', 'Vendor ');
            write('other_text', 'has not been added');
            write('complement', 'try again');
            write('bgColor', logMsgBgColors.error);
        }
    }, [RESPONSES.createVendorResponse]);

    return (
        <div
            className='modal-wrapper'
            style={{ height: '100vh' }}
        >
            <div
                className='settings-edit-modal'
                style={{ width: isMobile ? '345px' : '' }}
            >
                <form onSubmit={createForm.handleSubmit(onSubmit)}>
                    <div className='settings-edit-modal-content' style={{ margin: isMobile ? '35px 19px 0 21px' : '' }}>
                        <div className='modal-header'>
                            <p className='modal-title'>Add vendor</p>
                            <div className='Oval' onClick={props.toggler.toggle}>
                                <img src={`${toIcons}/close.svg`} alt='Close' />
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '25px',
                                marginTop: '22px',
                            }}
                        >
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Name'
                                name='name'
                                type='text'
                                register={createForm.register}
                                errors={createForm.formState.errors}
                                constraints={{ required: true }}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Code'
                                name='code'
                                type='text'
                                register={createForm.register}
                                errors={createForm.formState.errors}
                            />
                            <div>
                                <p className='field-label' style={{ marginBottom: 8 }}>Shipping rules (policy)</p>
                                <div style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid #eee', borderRadius: 8, padding: 8 }}>
                                    {shippingRules.map((rule) => (
                                        <label key={rule.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, cursor: 'pointer' }}>
                                            <input
                                                type='checkbox'
                                                checked={selectedRuleIds.includes(rule.id)}
                                                onChange={() => toggleRule(rule.id)}
                                            />
                                            <span style={{ fontFamily: 'Roboto', fontSize: 14 }}>{rule.name}</span>
                                        </label>
                                    ))}
                                    {shippingRules.length === 0 && (
                                        <p style={{ fontFamily: 'Roboto', fontSize: 12, color: '#b2b3bd' }}>Nessuna regola disponibile</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <button
                            style={{
                                marginRight: '0',
                                width: isMobile ? '100%' : '105px',
                            }}
                            className='modal-button'
                            type='submit'
                        >
                            <p className='modal-button-text'>Add</p>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SettingsCreateVendorModal;
